import { isNavigationFailure, NavigationFailureType } from 'vue-router'

import type { SamePageScroll } from 'types/scroll'

// Navigating to the current route is aborted as duplicated, so clicking the link of the page you are on does nothing by default.
export function useSamePageScroll(): SamePageScroll {
  const router = useRouter()

  function start(): void {
    router.afterEach((to, from, failure) => {
      // A hash targets a section: the router scrolled there already.
      if (to.hash || !isNavigationFailure(failure, NavigationFailureType.duplicated)) {
        return
      }

      const isMotionReduced = window.matchMedia(ANIMATION_REDUCED_MOTION_QUERY).matches

      window.scrollTo({ top: 0, behavior: isMotionReduced ? 'auto' : 'smooth' })
    })
  }

  return {
    start
  }
}
